import React, { createRef } from "react";
import styled from "styled-components";
import { PostData } from "../Functions/SendingData";
import {NotFindContent} from "../Functions/NotFindContent";
import { goodpageText } from "../../Lang/fa/Goodpage";
import { baseText } from "../../Lang/fa/UserPannel/UserPannel";
import Star from '../../assets/newSvg/star'; 
import { insertError } from "../StakcableError";
import GLike from '../../assets/newSvg/like-g.svg';
import GDislike from '../../assets/newSvg/dislike-g.svg'
import GoodCommentForm from "./GoodCommentForm";
import { Dialog } from "@material-ui/core";

const Styles = styled.div`
    display: grid;
    grid-template-columns: 23% 75%;
    grid-gap: 2%;    
    height: 100%;
    overflow-y: auto;
    position: relative;
    .bord{
        background: var(--body-2);
        border-radius: var(--border-radius-9);
        padding: 1.5rem;
        width: calc(100% - 3rem);
        color:var(--text-2);
        height: 12rem;
        .g-rate{
            display: flex;
            flex-direction: row;
            border-bottom: var(--border-style-2);
            align-items: center;
            padding: 0.2rem 0;
            margin-bottom: 1rem;
            .star{
                width: 2rem;
            }
        }
        .question{
            font-weight: bold;
            margin: 0;
            font-size: var(--fs-good-page-comment-question);
        }
        .text{
            position: relative;
            font-weight: 600;
            font-size:0.75rem;
            color: var(--gray-4);
        }
        .add{
            border-radius: var(--border-radius-2);
            padding: 0.8rem 1.5rem;
            color: var(--primary-5);
            border: 1px solid var(--primary-5);
            display: flex;
            justify-content: center;
            position: relative;
            width: calc(100% - 3rem);
            cursor: pointer;
            font-size:1rem;
            font-weight: 500;
            text-decoration: none;
            margin-top: 1rem;
        }
        .dis{
            cursor: default;
            opacity: 0.5;
        }
    }
    .comments{
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: flex-start;
        position: relative;
        .more-btn{
            color: var(--primary-8);
            border: var(--border-style-6);
            border-radius: var(--border-radius-9);
            padding: 0.8rem 1rem;
            width: 20%;
            text-align: center;
            font-size: 0.87rem;
            margin: auto;
            font-weight: 700;
            background: rgba(3, 130, 160, 0.10);
        }
        .comment{
            background: var(--body-2);
            border-radius: var(--border-radius-9);
            padding: 1.5rem ;
            width: calc(100% - 3rem);
            margin-bottom: 0.75rem; 
            position: relative;
            .user, .cmtfield{
                position: relative;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .star{
                    display: flex;
                    flex-direction: row-reverse;
                }
            }
            .user-com{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                border-bottom: var(--border-style-2);
                .user{
                    display: flex;
                    flex-direction: column;
                    .user-rate{
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        font-size:0.75rem;
                        font-weight: 500;
                        justify-content: flex-start ;
                        .star{
                            width: 1rem;
                            height: 1rem;
                            aspect-ratio: 1;
                            margin-left: 0.5rem;
                        }
                        .cmttitle{
                            border-right: var(--border-style-2);
                            display: flex;
                            align-items: center;
                            margin-right:0.5rem;
                            padding-right:0.5rem;
                            text-align: right;
                            font-size:0.75rem;
                            font-weight: 700;
                            .cm-svg{
                                width: 1rem;
                                height: 1rem;
                                margin-left: 0.2rem;
                                aspect-ratio: 1;
                            }
                        }
                    }
                    .names{
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        padding: 1rem 0;
                        span{
                            color: var(--gray-6);
                            font-size: 0.75rem;
                            font-weight: 500;
                            padding: 0 0.5rem;
                        }
                        .date{
                            border-left: var(--border-style-2)
                        }
                    }
                }
                .shop{
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    .logo{
                        width: 2.5rem;
                        height: 2.5rem;
                        aspect-ratio: 1;
                        border-radius: var(--border-radius-7);
                        border: var(--border-style-2);
                    }
                    .from{
                        display: flex;
                        flex-direction: column;
                        justify-content: start;
                        font-weight: 1rem;
                        font-weight: 700;
                    }
                }
            }
            .cmtfield{
                padding: 1rem 0;  
                .cmttext{
                    font-weight: 600;
                    font-size: 0.87 ;
                    color: var(--gray-4);
                }
            }

        }
    }
    @media screen and (max-width:850px){
        display: flex;
        flex-direction: column;
        width: 100%;
        .bord{
            padding: 1rem 1.5rem;
            position: relative;
            height: auto;
        }
        .comments{
            margin: 0.75rem 0;
            .more-btn{
                width: 50%;
            }
            .comment{
                padding-bottom: 0;
                .cmtfield{
                    align-items: flex-start;
                    flex-direction: column ;
                    .star{
                        width: 1rem;
                        height: 1rem;
                        aspect-ratio: 1;
                        margin-left: 0.5rem;
                    }
                    .cmttitle{
                        white-space: normal ;
                        height: 1.5rem;
                        padding: 0.2rem;
                        margin: 0.5rem 0;
                        font-size:0.62rem
                    }
                }
                .user{
                    width: 80%;
                }
                .user-com .shop{
                    flex-direction: column;
                    align-items: center;
                    .logo{
                        width:1.8rem;
                        height: 1.8rem;
                    }
                    .from{
                        font-size: 0.75rem;
                        text-align: justify;
                    }
                }
            }
        }
    }
`;


class GoodComments extends React.Component {
    constructor(props) {
        super(props);
        this.add = createRef()
        this.state = {
            suggest: '',
            show:false,
            objectData:[],
            objectData2:[]
        };
    }
    componentDidMount () {
        this.getData();
    }
    getData = () => {
        let formData = new FormData();
        formData.append("SH_G_CODE", this.props.shcode);
        formData.append("G_CODE", this.props.code);
        formData.append("U_G_COMM_CONTROL", 1);
        PostData(
            process.env.REACT_APP_API + "/api/v1/goods/user_goods_comment/select_by_g_code",
            formData,
            this,
            this.Proccess
          );
        
    }
    Proccess(obj, data){
        let response = JSON.parse(data);
        if (response.status === 'success') {    
            obj.setState({
                response: 'success',
                length: response.comment.length,
                objectData: response.comment,
                objectData2: response.comment.slice(0 , 3),
                sending: false
            });
        } else if (response.status === 'error') {
            obj.setState({
                response: 'success',
                sending: false
            });
        } else if (response.status === 'error-no-internet') {
            obj.setState({
                sending: false
            });
        }
    }
    scrolltop=()=>{
        if(window.innerWidth > 850){
            return 1300;
        }else{
            return 850
        }
    }
    addNew=()=>{
        window.scrollTo({
            top: this.add.current.offsetTop +  this.scrolltop(),
            behavior:"smooth"
        })
    }
    btnShow=()=>{
        if(this.props.userAllow === 1){
            this.setState({
                show : true
            })
        }else{
            insertError('برای ثبت نظر لطفا وارد حساب کاربری خود شوید', 'red', 5000)
        }
    }
    close=()=>{
        this.setState({
            show :false
        })
    }
    topbord=()=>{
        return(
            <div className="bord">
                <div className="g-rate">
                    <Star className='star' color={'var(--star)'} />
                    <div><span style={{fontSize:'1.2rem' , fontWeight:'600'}}>{this.props.all.Ave}</span> از  5( {this.props.cmCount} نظر )<span></span></div>
                </div>
                <span className="text" >{goodpageText.commentText}</span>
                <div className={'add '+ (this.props.userAllow === 1 ? '':'dis')} onClick={this.btnShow}>{baseText.addnewComment}</div>
            </div>
        )
    }
    recommend=(com)=>{
        let rec= com.U_G_COMM_USER_RECOMMAND
        if(rec === 0){
            return(goodpageText.binazar)
        }else if(rec === 1){
            return (goodpageText.razi)
        }else{
            return (goodpageText.narazi)
        }
    }
    recommendSvg=(com)=>{
        let rec= com.U_G_COMM_USER_RECOMMAND
        if(rec === 0){
            return 
        }else if(rec === 1){
            return <img alt='Like' src={GLike} className="cm-svg"/>
        }else{
            return <img alt='Dislike' src={GDislike} className="cm-svg"/>
        }
    }
    color=(com)=>{
        let bgcolor= com.U_G_COMM_USER_RECOMMAND
        if(bgcolor === 0){
            return 'var(--secondry-6)'          
        }else if(bgcolor === 1){ 
            return 'var(--primary-11)'
        }else{
            return 'var(--secondry-5)'         
        }
    };
    everyComment=()=>{
        if(this.state.length){
            let comment = this.state.objectData2.map((com , index)=>{
                return(
                    <div className="comment" key={index}>
                    <div className="user-com">
                        <div className="user">
                            <div className="user-rate">
                                <Star color={this.color(com)} classname={'star'} />
                                <div style={{whiteSpace:'nowrap'}}><span style={{color:this.color(com) ,fontSize:'1rem', fontWeight:'700'}}>{com.U_G_COMM_GOODS_SCORE} </span> از 5</div>
                                <div className={"cmttitle " + this.color(com)} style={{color:this.color(com)}}> 
                                    {this.recommendSvg(com)}
                                    {this.recommend(com)}
                                </div>
                            </div>
                            <div className="names">
                                <span className="date">{com.U_G_COMM_DATE}</span>
                                <span>{com.U_G_COMM_USER_VIEW ? com.U_FNAME : goodpageText.customer}</span>
                            </div>
                        </div>
                        {com.SH_NAME ? 
                            <div className="shop">
                                <img alt={com.SH_NAME} src={com.SH_LOGO} className="logo"/>
                                <div className="from">
                                    {window.innerWidth > 850 ? <span>خریداری شده از: </span> : ''}
                                    <span style={{color:'var(--gray-13)'}} > {com.SH_NAME} </span>
                                </div>
                            </div>
                            : '' 
                        }
                    </div>
                    <div className="cmtfield">
                        <div className="cmttext">{com.U_G_COMM_DESC}</div>
                        {/* <div className={"cmttitle " + this.color(com)}> 
                        {this.recommend(com)}
                        </div> */}
                    </div>
                </div>
                )
            })
            return comment
        }else{
            return <div className="empty"><NotFindContent text={goodpageText.notfind} /></div>
        }
    }
    //more btn
    showMore = () => {
        if(this.state.partCom < this.state.length){
            let newCom = this.state.partCom + 3
            this.setState({
                partCom:newCom,
                objectData2 : this.state.objectData.slice(0 , newCom)
            })
        }
    }
    commentsbord=()=>{
        return(
            <div className='comments'>
                {this.everyComment()}
                {
                    this.state.length > this.state.partCom ? (
                        <div className="more-btn" onClick={this.showMore} >{goodpageText.more}</div>
                    ):''
                }
            </div>
        )
    }
    showPop=()=>{
        if(this.state.show){
            return (
                <Dialog
                    fullWidth={true}
                    maxWidth={'xs'}
                    open={this.state.show}
                    onClose={''}
                    style={{backgroundColor: 'rgba(0,0,0,0.5)'}}
                >
                    <GoodCommentForm close={this.close} {...this.props} gcode={this.props.code} shgcode={this.props.shgcode} onClick={ this.addNew }/>
                </Dialog>
            )
        }
        return
    }
    render() {
        return (
            <Styles ref={this.add}>
                {this.topbord()}
                {this.commentsbord()}
                {this.showPop()}
            </Styles>
        );
    }
}

export default GoodComments;
